import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { GAME_STAGE } from "../../utils/constant";
import { history } from "../../index";
import { checkGameStatus, fetchHistory } from "../../service/logic";
import { saveHistoryTaking } from "../../redux/dispatchers";
import { GameModalLayout } from "../common";
import Messages from "./Messages/Messages";
import Input from "./Input/Input";
import { fontSize } from "../../styles";
import { v4 as uuidv4 } from "uuid";
import { renderReply } from "./index";

const useStyles = makeStyles(() => ({
  chatBox: {
    height: "75vh",
  },
  chatContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    background: "#FFFFFF",
    height: "100%",
    width: "100%",
    borderRadius: "1%",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    background: "white",
    marginTop: 10,
    borderRadius: 10,
  },
  input: {
    alignSelf: "center",
    fontSize: fontSize.h3,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: `0px solid white`,
      },
      "&.Mui-focused fieldset": {
        border: `0px solid white`, // focus
      },
    },
    flex: 6,
  },
  gridList: {
    height: 330,
    padding: 0,
    overflowY: "auto",
  },
  askedHistoryContainer: {
    flex: 9,
    paddingTop: 10,
  },
  listItem: {
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
  },
}));

function Interview() {
  const { historyTaking } = useSelector((state) => state.gameStates);
  const classes = useStyles();
  const [question, setQuestion] = useState("");
  const [asking, setAsking] = useState(false);

  const onAsk = async (e) => {
    if (!!e) e.preventDefault();
    // empty question or currently asking
    if (!question.length || asking) {
      return;
    }
    setAsking(true);

    const result = await fetchHistory(question);
    setQuestion("");
    saveHistoryTaking({
      id: uuidv4(),
      isCurrentUser: true,
      content: question,
      timestamp: +new Date(),
    });

    if (!result) {
      saveHistoryTaking({
        id: uuidv4(),
        isCurrentUser: false,
        content: "Sorry I don't understand what you were asking.",
        timestamp: +new Date(),
      });
      setAsking(false);
      return;
    }

    if (result.length === 1) {
      renderReply(result[0]);
    } else {
      saveHistoryTaking({
        id: uuidv4(),
        isCurrentUser: false,
        content: result,
        timestamp: +new Date(),
      });
    }
    setAsking(false);
  };

  useEffect(() => {
    // check if user is allowed to enter history taking page
    if (!checkGameStatus(GAME_STAGE.HISTORY_TAKING)) {
      // if not allowed, navigate to case list page
      history.push("/cases");
    }
  }, []);

  return (
    <React.Fragment>
      <CssBaseline />
      <GameModalLayout
        left={
          <div className={classes.chatBox}>
            <div className={classes.chatContainer}>
              <Messages messages={historyTaking} />
              <Input
                message={question}
                setMessage={setQuestion}
                sendMessage={onAsk}
              />
            </div>
          </div>
        }
        answerHalfCenterShift
      />
    </React.Fragment>
  );
}

export default Interview;
